export const {
  REACT_APP_API_VERSION,
  REACT_APP_FRONT_URL,
  REACT_APP_API_BASE_URL,
} = process.env;
export const REACT_APP_API_URL = `${process.env.REACT_APP_API_URL}${REACT_APP_API_VERSION}`;
export const REACT_APP_API_URL_WITHOUT_VERSION = process.env.REACT_APP_API_URL;
